<template>
  <div ref="nav" class="nav">
    <div class="nav-left">
      <div class="back-area" id="back" @click="back">
        <div style="font-size:16px">
          <i class="cubeic-back"></i>
        </div>
        <div class="leftTitle" v-if="leftTitle">{{ leftTitle }}</div>
        <div v-if="showClose" style="font-size: 23px;" @click.stop="close">
          <i class="cubeic-close"></i>
        </div>
      </div>
    </div>
    <div class="nav-middle">
      <span class="title">{{ title }}</span>
    </div>
    <div class="nav-right">
      <slot>
        <div class="nav-right-content" @click="rightBtn">
          <span class="click-size">{{ btnText }}</span>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String, // 标题
    btnText: String, // btn文字
    showClose: { // 显示关闭按钮
      type: Boolean,
      default: false
    },
    leftTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    rightBtn() {
      this.$emit('rightBtn');
    },
    back() {
      this.$emit('back');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
$navColor: #008CFE; //nav背景颜色
$navTextColor: #FFFFFF; // nav字体颜色
$navHeight: 44px; // nav高度

.nav {
  width: 100%;
  height: 44px;
  background-color: $navColor;
  color: $navTextColor;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 9;

  // box-shadow: 0 2px 3px #eaeaea;
  .click-size.size {
    font-size: 15px;
  }

  .title {
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 2px;
  }
}

.nav-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    margin-right: 5px;
  }
  .leftTitle{
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.nav-middle {
  width: 60%;
  flex: 1;
  text-align: center;

  .title {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    /*强制在一行显示*/
    text-overflow: ellipsis;
    /*设置超出内容显示...*/
    overflow: hidden;
    /*一定不能少 超出的内容进行隐藏*/
  }
}

.nav-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 20%;
  height: $navHeight;

  .nav-right-text {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 65px;
    height: $navHeight;

    &:active {
      background-color: $navColor;
    }
  }

  .nav-right-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: flex-end;
    width: 100%;
    height: $navHeight;
    margin-right: 10px;

    img {
      width: 25px;
    }
  }
}

.back-area {
  height: $navHeight;
  //   width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  cursor: pointer;

  >div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: $navHeight;
    margin-right: 10px;
  }

  &:active {
    background-color: $navColor;
  }

  .text {
    color: #0093dd;
    font-size: 15px;
  }
}

.back-img {
  overflow: hidden;

  img {
    height: 18px !important;
  }
}

.information-img {
  height: 18px !important;
  margin-right: 2px;
}</style>
